import { render, staticRenderFns } from "./PermissionItem.vue?vue&type=template&id=46b27b68&scoped=true"
import script from "./PermissionItem.vue?vue&type=script&lang=js"
export * from "./PermissionItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b27b68",
  null
  
)

export default component.exports